import { useContext } from "react"
import { useHistory } from "react-router-dom"
import { WalletContext } from "../Context/WalletContext"
import { Table, Button } from "antd"

const Walletyan = () => {

    const history = useHistory()
    const [userWallet] = useContext(WalletContext)

    const HandleCreateWallet = () => {
        history.push("/walletyan/create")
    }

    const HandleTopUpWallet = () => {
        history.push("/walletyan/topup")
    }

    const columnsWallet = [
        {title: 'Walletyan', dataIndex: 'key', width: '250px'},{title: 'Data',dataIndex: 'value'}
    ]

    const balanceWallet = [
        {key: 'Balance', value: `${userWallet.balance}`},
        {key: 'Walletyan', value: <Button type="primary" size="small" onClick={HandleTopUpWallet}>Top Up Walletyan</Button>}
    ]

    const createWallet = [
        {key: 'Balance', value: <Button type="primary" size="small" onClick={HandleCreateWallet}>Create Walletyan</Button>}
    ]

    const isWallet = userWallet.userId !== undefined

    return(
        <>
        <h1>Walletyan</h1>        
        {isWallet ? 
        <Table style={{marginTop: "20px"}} columns={columnsWallet} dataSource={balanceWallet} pagination={false} />
        :
        <Table style={{marginTop: "20px"}} columns={columnsWallet} dataSource={createWallet} pagination={false} />
        }
        </>
    )
}

export default Walletyan